import { TranslationConfig } from '@coolblue-development/next-translations';

import dictionary from './dictionary.json';

const config: TranslationConfig = {
  resource: 'product-page-microfrontend',
  dictionary
};

export default config;
